import React from "react";
import {
  updateProfile,
  updateEmail,
  sendPasswordResetEmail,
  sendEmailVerification,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";

import { UserContext } from "../../Context/UserContext";
import { Head } from "../../Utils/Head";
import { Input } from "../Forms/Input";
import { Button } from "../Forms/Button";
import { useForm } from "../../Hooks/useForm";
import { auth } from "../../firebaseConfig";
import { updateUserFirebase } from "../../Utils/firebaseUser";

export const Account = () => {
  const { user, userData, setUserData } = React.useContext(UserContext);
  const email = useForm("email");
  const name = useForm();
  const [displayName, setDisplayName] = React.useState("");
  const [userEmail, setUserEmail] = React.useState("");
  const [emailSended, setEmailSended] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    setDisplayName(user.displayName);
    setUserEmail(user.email);
  }, [user]);

  const handleResetJourney = () => {
    const updatedJourney = {
      level: 0,
      lesson: 0,
    };
    userData.journey = updatedJourney;
    setUserData(userData);
    updateUserFirebase(userData);
    navigate("/");
  };

  function handleSubmitProfile(e) {
    e.preventDefault();
    userData.displayName = name.value;
    setUserData(userData);
    updateUserFirebase(userData);
    updateProfile(auth.currentUser, {
      displayName: name.value,
    });
    setDisplayName(name.value);
    navigate("/");
  }

  function handleSubmitEmail(event) {
    event.preventDefault();
    userData.email = email.value;
    setUserData(userData);
    updateUserFirebase(userData);
    updateEmail(auth.currentUser, email.value);
    updateProfile(auth.currentUser, { emailVerified: false });
    setUserEmail(email.value);
    sendEmailVerification(auth.currentUser).then(() => {
      console.log("Email verification sent!");
      // ...
    });
    navigate("/");
  }

  return (
    <div className="containerContent">
      <Head title="Profile" />
      <h4 className="title">Perfil</h4>
      {user && userData && (
        <>
          <p>Nome: {displayName}</p>
          <p>Email: {userEmail}</p>
          {/* <p>Nível: {userData.journey ? userData.journey.level : 0}</p>
          <button className="greenButton">
            Reiniciar Jornada (retornar para nível 0)
          </button> */}

          {/* <h4>Atualizar Nome</h4>
          <form action="" onSubmit={handleSubmitProfile}>
            <Input type="name" name="name" required={true} {...name} />
            <Button>Enviar</Button>
          </form>
          <form action="" onSubmit={handleSubmitEmail}>
            <h4>Atualizar Email</h4>
            <Input type="email" name="email" {...email} />
            <Button>Enviar</Button>
          </form>
          <h4>Alterar Senha</h4>
          <button
            className="greenButton"
            onClick={() => {
              setEmailSended(true);
              sendPasswordResetEmail(auth, user.email).then(() => {
                console.log("Password reset email sent!");
              });
            }}
          >
            Aperte aqui para enviar um email para alterar a senha
          </button>
          {emailSended && <div>email enviado</div>} */}
        </>
      )}
    </div>
  );
};
